import React from 'react'
import * as S from './styles'
import DateHeader from '..//DateHeader'

const DetailedCards = ({ title, subtitle, details, loading, skeletonCards }) => {
  const header = { title, subtitle, loading }
  return (
    <S.Container>
      {
        !loading
          ? <>
            <DateHeader {...header} />
            <S.Details>
              {details}
            </S.Details>
          </>
          : <>
            <S.SkeletonCard type='title' />
            <S.SkeletonCard type='subtitle' />
            {Array(skeletonCards ?? 3).fill().map((_, index) => <S.SkeletonCard type='card' key={index} />)}
          </>
      }
    </S.Container>
  )
}

export default DetailedCards
